﻿import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../../store/lista';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return, Select} from '../inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';

import TemPermissao from '../../helpers/TemPermissao';
import { ROLE_EMAIL, ROLE_SMS } from '../../store/roles';

class ListaUpload extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,

            form: this.formInitialState(),

            file: null,

            comboTipoListaContato: {
                results: undefined
            },

            tipoListaContatoUnico: false,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
    }

    formInitialState() {

        return {
            nomeListaContato: "",
            file: "",
            tipoListaContato: "",
        }

    }

    componentDidMount() {
        this.loadTipoListaContato();
    }

    loadTipoListaContato() {
        self = this;

        const url = `${c.API_BASE_URL}/combo-tipo-lista-contato`;
        const options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

        callApi(url, options, function (response) {
    
            if(response.results !== 'undefined' && response.results.length === 1){

                self.setState({ ...self.state, comboTipoListaContato: response,form: {...self.state.form, tipoListaContato: response.results[0].value },tipoListaContatoUnico: true });

            }else{

                self.setState({ ...self.state, comboTipoListaContato: response , tipoListaContatoUnico:  false});
            }

        });
    }

    handleChange(e) {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    onChangeFile(e) {
        const form = this.state.form;

        form.file = e.target.files[0];

        this.setState({ file: e.target.files[0] });

        if (form.file != null) {
            document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name
        } else {
            document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        }
    }

    handleSave(e) {
        e.preventDefault(); if (this.state.loading) return;
        if (this.state.form.file === '' || isBlank(this.state.form.nomeListaContato) || this.state.form.tipoListaContato === "") {
            c.TOASTER_ERROR('Favor incluir o tipo, nome do arquivo e o arquivo.');

        } else {

            this.setState({ ...this.state, loading: true });

            let idUsuario = this.props.auth.user.id;
            this.state.form.usuario = idUsuario;

            this.props.actions.lista.upload(this.state.form).then((response) => {
                this.setState({ ...this.state, loading: false });
                if (response.status !== 'BAD_REQUEST') {
                    c.TOASTER_SUCCESS("Upload realizado com sucesso!");
                    this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/mapear", { response: response });

                } else {
                    c.TOASTER_ERROR(response.message);

                }

            }).catch((error) => {
                this.setState({ ...this.state, loading: false });
                if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
            });

        }

    }

    render() {
        const form = this.state.form;

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-5">
                    <Column>
                        <IBox>
                            <Title className="pt-5 text-center">
                                <h2 className="fs-20 fw-600 text-body">Upload de Arquivo</h2>

                                <h5 className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: Formato de arquivos separados por ponto e vírgula (*.csv; .txt).</h5>
                                <TemPermissao permissao={ROLE_EMAIL}>
                                    <p />
                                    <h5 className="fs-14 fw-400 text-body">A primeira linha do arquivo da lista de <b>E-mail</b> deverá conter o nome dos campos: (nome; email...)</h5>
                                    <h5 className="fs-14 fw-400 text-body">O conteúdo do arquivo deverá ser separado por ponto e vírgula. Ex.: (Montreal; montreal@montreal.com.br)</h5>
                                    <p />
                                </TemPermissao>
                                <TemPermissao permissao={ROLE_SMS}>
                                    <p />
                                    <h5 className="fs-14 fw-400 text-body">A primeira linha do arquivo da lista de <b>SMS</b> deverá conter o nome dos campos: (nome; sms)</h5>
                                    <h5 className="fs-14 fw-400 text-body">O conteúdo do arquivo deverá ser separado por ponto e vírgula. Ex.: (Montreal; 31999999999)</h5>
                                    <h5 className="fs-14 fw-400 text-body"><b>Importante</b>: Limite de carregamento por lista de contato de 200.000 registros</h5>
                                    <p />
                                </TemPermissao>
                            </Title>

                            <Content className="p-3 border-0">
                                {/* FORMULÁRIO */}
                                <Row className="m-0 mb-5">
                                    <Column size="9" className="container mx-auto p-0">

                                        <Row className="mt-1">
                                            <Column size="4" className="px-1">
                                                <label for="tipoListaContato">Tipo da lista</label>
                                                <Select name="tipoListaContato" selected={this.state.form.tipoListaContato}  data={this.state.comboTipoListaContato} disabled={this.state.tipoListaContatoUnico} onChange={this.handleChange} placeholder="Tipo da lista de contato" />
                                            </Column>
                                        </Row>

                                        <Row className="mt-4">
                                            <Column size="7" className="px-1">

                                                <div className="input-group">
                                                    <input type="text" name="nomeListaContato" value={form.nomeListaContato} onChange={this.handleChange} placeholder="Nome da nova Lista" className="form-control" />
                                                </div>

                                            </Column>

                                            <Column size="5" className="px-1">

                                                <div className="custom-file">
                                                    <input type="file" name="file" className="custom-file-input" id="validatedCustomFile" required value={this.state.arquivo} onChange={this.onChangeFile} />
                                                    <label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
                                                </div>

                                            </Column>
                                        </Row>

                                    </Column>
                                </Row>

                                {/* NAVEGAÇÃO */}
                                <Row className="m-0 mb-3">
                                    <Column size="auto" className="mx-auto">
                                        <div className="input-group">

                                            <Return to={c.CAMPAIGN_ROUTE + "/lista"} className="mx-1" width="130px" />
                                            <Button onClick={this.handleSave} className="mx-1" width="130px">Próximo</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>
                                        </div>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch) {
    return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ListaUpload));
